import { BaseTextMergeContainerElement } from "../BaseTextMergeContainerElement";
import { BaseTextMergeElement } from "../BaseTextMergeElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { StyleElement } from "./StyleElement";
import { DataDefinition } from "../../../Common/Data/DataDefinition";
import { TextMergeType } from "../../TextMergeType";
import { StateManager } from "../../../Common/StateManager";
import { XMLAttributeElement } from "../JSONXML/XMLAttributeElement";

class RenderList {
    render: BaseTextMergeElement[] = [];
}

export class RootTextElement extends BaseTextMergeContainerElement {
    readonly __type: string = "root";
    readonly name: string = "__root... should not see this";
    readonly styleElement: boolean = true;
    readonly ordinal: number = 10;
    inputData: undefined | (() => DataDefinition);

    private _xmlRootElementName: string = "Value";

    get xmlRootElementName(): string {
        return this._xmlRootElementName;
    }

    set xmlRootElementName(value: string) {
        this._xmlRootElementName = value;
        StateManager.propertyChanged(this, "xmlRootElementName");
    }

    getHTMLTag(): string {
        return "p";
    }

    output(data: ExecutionData, config: TextMergeConfiguration, testContext: ITestingContext | undefined): string {
        if (config.type === TextMergeType.JSON) {
            let result = "{\n";

            for (let e of this.elements) result = result + e.output(data, config, testContext) + "\n";

            result = result + "\n}";

            return result;
        } else if (config.type === TextMergeType.XML) {
            return XMLAttributeElement.outputXMLContainer(
                config,
                config.rootElement,
                config.rootElement.xmlRootElementName,
                data,
                testContext
            );
        } else {
            return this.outputString(data, config, testContext);
        }
    }

    canAdd(_config: TextMergeConfiguration): boolean {
        return false;
    }

    setInputData(inputDataFunction: () => DataDefinition) {
        this.inputData = inputDataFunction;
    }

    override getInputData(): DataDefinition {
        if (!this.inputData) return new DataDefinition();
        return this.inputData();
    }

    private outputString(
        data: ExecutionData,
        config: TextMergeConfiguration,
        testContext: ITestingContext | undefined
    ) {
        let renderStuff: (RenderList | BaseTextMergeContainerElement)[] = [];

        let currentRenderList = new RenderList();

        renderStuff.push(currentRenderList);
        for (let e of this.elements) {
            if (e instanceof BaseTextMergeContainerElement) {
                if (e instanceof StyleElement && e.newParagraph === false) {
                    currentRenderList.render.push(e);
                } else {
                    renderStuff.push(e);
                    currentRenderList = new RenderList();
                    renderStuff.push(currentRenderList);
                }
            } else {
                currentRenderList.render.push(e);
            }
        }

        return renderStuff
            .map((rs) => {
                if (rs instanceof RenderList) {
                    let output = '<p style="' + this.getStyles().styles + '">';

                    output =
                        output +
                        rs.render
                            .map((ri) => {
                                return ri.output(data, config, testContext);
                            })
                            .join(" ");

                    output = output + "</p>";
                    return output;
                } else {
                    return rs.output(data, config, testContext);
                }
            })
            .join(" ");
    }
}
